"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedAccountPlatform = exports.GetUsersFilter = exports.AuthGroup = exports.SocialPlatform = void 0;
var SocialPlatform;
(function (SocialPlatform) {
    SocialPlatform["Steam"] = "steam";
})(SocialPlatform || (exports.SocialPlatform = SocialPlatform = {}));
var AuthGroup;
(function (AuthGroup) {
    AuthGroup["User"] = "user";
    AuthGroup["Admin"] = "admin";
    AuthGroup["Creator"] = "creator";
    AuthGroup["Viewer"] = "viewer";
    AuthGroup["Brand"] = "brand";
    AuthGroup["BrandAdmin"] = "brandAdmin";
    AuthGroup["BrandUser"] = "brandUser";
    AuthGroup["SuperAdmin"] = "superAdmin";
    AuthGroup["Agency"] = "agency";
    AuthGroup["AgencyAccountManager"] = "agencyAccountManager";
    AuthGroup["BetaTester"] = "betaTester";
})(AuthGroup || (exports.AuthGroup = AuthGroup = {}));
var GetUsersFilter;
(function (GetUsersFilter) {
    GetUsersFilter["Email"] = "email";
    GetUsersFilter["UserId"] = "userId";
    GetUsersFilter["ParentUserId"] = "parentUserId";
    GetUsersFilter["Group"] = "group";
})(GetUsersFilter || (exports.GetUsersFilter = GetUsersFilter = {}));
var ConnectedAccountPlatform;
(function (ConnectedAccountPlatform) {
    ConnectedAccountPlatform["YouTube"] = "youtube";
    ConnectedAccountPlatform["Google"] = "google";
})(ConnectedAccountPlatform || (exports.ConnectedAccountPlatform = ConnectedAccountPlatform = {}));
